import { connect } from 'react-redux';

import { openDownload, openLogin } from 'depop/state/navigation';

export const loginConnector = connect(null, dispatch => ({
  openLogin: () => dispatch(openLogin()),
}));

export const downloadConnector = connect(null, dispatch => ({
  openDownload: () => dispatch(openDownload()),
}));



// WEBPACK FOOTER //
// ../src/client/connectors.js